













































import {Vue, Component} from "vue-property-decorator";
import {State} from "vuex-class";
import {PictionaryInterface} from "@/models/pictionary";
import TextToSpeech from "@/components/TextToSpeech.vue";


@Component({
    components:{
        TextToSpeech
    }
})
export default class PictionaryPage extends Vue{
    @State(state => state.pictionary.pictionary) pictionary: PictionaryInterface[];
    public practice = 1;


    created(){
        this.$store.dispatch('bindPictionary', 'asc');
    }
}
